<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Promotion Factor Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 v-if="newPromoFact">
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete :label="labels.productType" v-model="appID" :items="appIDList" item-text="label" item-value="value" :error-messages="errors.collect('productType')" data-vv-name="productType" :data-vv-as="labels.productType" v-validate="'required'" @input="doProductType"></v-autocomplete>
                </v-flex>
                <v-flex xs8>
                  <v-autocomplete :label="labels.product" v-model="promoFactForm.product" :items="productList" item-text="label" item-value="value" :error-messages="errors.collect('product')" data-vv-name="product" :data-vv-as="labels.product" v-validate="'required'" :loading="productLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-else>
              <v-subheader class="queryLabel">{{labels.productQuery}}</v-subheader>
              <div class="title">{{promoFactForm.product}}</div>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete :items="factor1to3List" v-model="promoFactForm.fact1" :label="labels.fact1" item-text="label" item-value="value" :error-messages="errors.collect('fact1')" data-vv-name="fact1" :data-vv-as="labels.fact1" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor1to3List" v-model="promoFactForm.fact2" :label="labels.fact2" item-text="label" item-value="value" :error-messages="errors.collect('fact2')" data-vv-name="fact2" :data-vv-as="labels.fact2" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor1to3List" v-model="promoFactForm.fact3" :label="labels.fact3" item-text="label" item-value="value" :error-messages="errors.collect('fact3')" data-vv-name="fact3" :data-vv-as="labels.fact3" clearable></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete :items="factor4to6List" v-model="promoFactForm.fact4" :label="labels.fact4" item-text="label" item-value="value" :error-messages="errors.collect('fact4')" data-vv-name="fact4" :data-vv-as="labels.fact4" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor4to6List" v-model="promoFactForm.fact5" :label="labels.fact5" item-text="label" item-value="value" :error-messages="errors.collect('fact5')" data-vv-name="fact5" :data-vv-as="labels.fact5" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete :items="factor4to6List" v-model="promoFactForm.fact6" :label="labels.fact6" item-text="label" item-value="value" :error-messages="errors.collect('fact6')" data-vv-name="fact6" :data-vv-as="labels.fact6" clearable></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                {{newPromoFact? 'Add Promotion Factor' : 'Update Promotion Factor'}}
                <v-icon right>{{newPromoFact? 'mdi-sale' : 'mdi-content-save'}}</v-icon>
                </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <promotion-rates v-if="!newPromoFact" :promoRates="promoRates" :promoFacts="factorForm" @doRemove="doRemove"></promotion-rates>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import PromotionRates from './PromotionRates'
import { PROMOTION_PROMOFACT, PROMOTION_PROMOFACT_TABMENU, PROMOTION_FACTORLIST } from '@/store/types'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        productType: 'Product Type*',
        product: 'Product*',
        productQuery: 'Product',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6'
      },
      promoFactForm: {
        promotion: undefined,
        product: undefined,
        fact1: undefined,
        fact2: undefined,
        fact3: undefined,
        fact4: undefined,
        fact5: undefined,
        fact6: undefined,
        revision: undefined
      },
      appID: undefined,
      productLoading: false,
      productList: [],
      menu: [],
      newPromoFact: false,
      submitting: false,
      promoRates: [],
      factor1to3Loading: false,
      factor1to3List: [],
      factor4to6Loading: false,
      factor4to6List: []
    }
  },
  computed: {
    appIDList() {
      return this.$store.state.promotionManagement.promotion.appIDList
    },
    factorForm() {
      const result = {
        fact1: this.promoFactForm.fact1,
        fact2: this.promoFactForm.fact2,
        fact3: this.promoFactForm.fact3,
        fact4: this.promoFactForm.fact4,
        fact5: this.promoFactForm.fact5,
        fact6: this.promoFactForm.fact6
      }
      return result
    }
  },
  methods: {
    async doInit() {
      if (!this.newPromoFact) {
        this.promoFactForm.product = this.product
        // Review
        await this.reviewPromoFact()
        await Promise.all([this.getFactor1to3List(), this.getFactor4to6List()])
        this.queryPromotionRates()
      }
    },
    async reviewPromoFact() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionFactorGet
      if (apiURI) {
        try {
          const expand = {
            promotion: this.promotion,
            product: this.promoFactForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion Factor init
            this.promoFactForm.promotion = data.promoFact.promotion
            this.promoFactForm.product = data.promoFact.product
            this.appID = data.promoFact.productAppId
            this.promoFactForm.fact1 = data.promoFact.fact1
            this.promoFactForm.fact2 = data.promoFact.fact2
            this.promoFactForm.fact3 = data.promoFact.fact3
            this.promoFactForm.fact4 = data.promoFact.fact4
            this.promoFactForm.fact5 = data.promoFact.fact5
            this.promoFactForm.fact6 = data.promoFact.fact6
            this.promoFactForm.revision = data.promoFact.revision

            const promoFactors = {
              fact1: this.promoFactForm.fact1,
              fact2: this.promoFactForm.fact2,
              fact3: this.promoFactForm.fact3,
              fact4: this.promoFactForm.fact4,
              fact5: this.promoFactForm.fact5,
              fact6: this.promoFactForm.fact6
            }
            this.$store.commit(PROMOTION_PROMOFACT, promoFactors)
            const commitData = {
              promoFactTab: 1,
              displayFactReviewTab: true,
              product: this.promoFactForm.product
            }
            this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doProductType() {
      this.getProducts()
      this.factor1to3List = undefined
      this.factor4to6List = undefined
      this.getFactor1to3List()
      this.getFactor4to6List()
      const commitData = {
        factor1to3List: this.factor1to3List,
        factor4to6List: this.factor4to6List,
        appId: this.appID
      }
      this.$store.commit(PROMOTION_FACTORLIST, commitData)
    },
    async getProducts() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.productList
      if (apiURI) {
        try {
          this.productLoading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.productList = data
          }
          this.productLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPromoFact) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoFactForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.reviewPromoFact()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionFactorCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoFactForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newPromoFact = false
            await this.reviewPromoFact()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async queryPromotionRates() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionRates
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion,
            product: this.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.promoRates = []
              data.map((promotionRate) => {
                const convertPromotionRate = {
                  promotion: promotionRate.promotion,
                  product: promotionRate.product,
                  commGN: promotionRate.commGN,
                  commPct: promotionRate.commPct,
                  discPct: promotionRate.discPct,
                  fact1: promotionRate.fact1,
                  fact2: promotionRate.fact2,
                  fact3: promotionRate.fact3,
                  fact4: this.formatDisplayNumber(promotionRate.fact4),
                  fact5: this.formatDisplayNumber(promotionRate.fact5),
                  fact6: this.formatDisplayNumber(promotionRate.fact6),
                  protComm: this.formatBoolean(promotionRate.protComm),
                  protDisc: this.formatBoolean(promotionRate.protDisc),
                  revision: promotionRate.revision
                }
                this.promoRates.push(convertPromotionRate)
              })
            } else {
              this.promoRates = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doRemove(selectedPromoRate) {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionRateDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          promotion: selectedPromoRate.promotion,
          product: selectedPromoRate.product,
          fact1: selectedPromoRate.fact1,
          fact2: selectedPromoRate.fact2,
          fact3: selectedPromoRate.fact3,
          fact4: selectedPromoRate.fact4,
          fact5: selectedPromoRate.fact5,
          fact6: selectedPromoRate.fact6
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryPromotionRates()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    async getFactor1to3List() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.factor1to3ListGet
      if (apiURI) {
        try {
          this.factor1to3Loading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.factor1to3List = data
          }
          const commitData = {
            factor1to3List: this.factor1to3List,
            factor4to6List: this.factor4to6List,
            appId: this.appID
          }
          this.$store.commit(PROMOTION_FACTORLIST, commitData)
          this.factor1to3Loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async getFactor4to6List() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.factor4to6ListGet
      if (apiURI) {
        try {
          this.factor4to6Loading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.factor4to6List = data
          }
          const commitData = {
            factor1to3List: this.factor1to3List,
            factor4to6List: this.factor4to6List,
            appId: this.appID
          }
          this.$store.commit(PROMOTION_FACTORLIST, commitData)
          this.factor4to6Loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    if (this.product === 'New') {
      this.newPromoFact = true
      this.promoFactForm.promotion = this.promotion
    } else {
      this.doInit()
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    PromotionRates
  }
}
</script>

<style lang="scss">

</style>
